module.exports = __webpack_public_path__ + "img/CellCycle-SCC_GSE144240.c2e1c04d.png";